import * as React from "react";
// import { pure } from 'recompose'
import DetailsCamera from "@tunnel-components/@sharded/camera/details/component";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { isOpen, camera, editioncamerasuccees, editioncameraerror, editionErrorIsDuplication } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isOpen}>
      <StyledComponent.ModalContainerInsider
        isVisible={isOpen}
        style={{ width: "700px" }}
      >
        {isOpen && (
          <Styled.CartContainer
            style={{
              padding: "10px",
              boxSizing: "border-box",
              position: "relative",
            }}
          >
            <DetailsCamera {...camera} />
          </Styled.CartContainer>
        )}
      </StyledComponent.ModalContainerInsider>
      <SnackBar
        style={{ backgroundColor: "#00E1B3" }}
        isVisible={editioncamerasuccees}
        someTextSuccees={i18next.t("la mise a jour de la camera a reussie")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={editioncameraerror && !editionErrorIsDuplication}
        someTextSuccees={i18next.t("la mise a jour de la camera a echouee")}
      />{" "}
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={editionErrorIsDuplication}
        someTextSuccees={i18next.t("ce nom de camera a deja ete utilise")}
      />{" "}      
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  isOpen?: any;
  camera?: any;
  disabled?: boolean;
  editioncamerasuccees?: boolean;
  editioncameraerror?: boolean;
  editionErrorIsDuplication?: boolean;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/details-camera/component.tsx